export const iconFontAwesomeMedicalHealthStaffSnake = (
	<i className="fa-solid fa-staff-snake"></i>
);
